export default __webpack_public_path__ + "static/media/AirMaxRed.c9bf2618.jpg";